import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export type CategorySort = 'default' | 'name' | 'recent' | 'media' | 'custom'
export type CategoryOrder = 'asc' | 'desc'

const SORTS: CategorySort[] = ['default', 'name', 'recent', 'media', 'custom']
const ORDERS: CategoryOrder[] = ['asc', 'desc']

interface Props {
  sort: CategorySort
  order: CategoryOrder
  onChange: (sort: CategorySort, order: CategoryOrder) => void
  onConfigure: () => void
  triggerClassName?: string
}

/** OnlyFans-style ordering for the folders themselves (not media inside them). */
export function CategorySortMenu({ sort, order, onChange, onConfigure, triggerClassName = 'lib-icon-btn' }: Props) {
  const { t } = useTranslation('library')
  const [open, setOpen] = useState(false)
  const label = t('vault.categorySort.label')

  return (
    <div className="lib-anchor lib-anchor--panel">
      <button
        type="button"
        className={triggerClassName}
        aria-label={label}
        title={label}
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="15" y2="12" />
          <line x1="3" y1="18" x2="9" y2="18" />
        </svg>
      </button>
      {open && (
        <>
          <div className="lib-backdrop" onClick={() => setOpen(false)} />
          <div className="lib-pop lib-cat-sort" role="dialog" aria-label={label}>
            <fieldset className="lib-cat-sort-group">
              <legend className="sr-only">{t('vault.categorySort.criterion')}</legend>
              {SORTS.map((key) => (
                <label key={key} className="lib-cat-sort-row">
                  <input
                    type="radio"
                    name="vault-category-sort"
                    checked={sort === key}
                    onChange={() => onChange(key, order)}
                  />
                  <span>{t(`vault.categorySort.${key}`)}</span>
                </label>
              ))}
            </fieldset>
            <fieldset className="lib-cat-sort-group lib-cat-sort-group--order">
              <legend className="sr-only">{t('vault.categorySort.direction')}</legend>
              {ORDERS.map((key) => (
                <label key={key} className="lib-cat-sort-row">
                  <input
                    type="radio"
                    name="vault-category-order"
                    checked={order === key}
                    onChange={() => onChange(sort, key)}
                  />
                  <span>{t(`vault.categorySort.${key}`)}</span>
                </label>
              ))}
            </fieldset>
            <button
              type="button"
              className="lib-cat-sort-configure"
              onClick={() => {
                onConfigure()
                setOpen(false)
              }}
            >
              {t('vault.categorySort.configure')}
            </button>
          </div>
        </>
      )}
    </div>
  )
}
